import React from 'react';

import { useState, useEffect } from 'react';

import makeStyles from '@mui/styles/makeStyles';

import axios from 'axios';


import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

import { green } from '@mui/material/colors';


const useStyles = makeStyles((theme) => ({
    formControl: {
        width: '100%',
        marginBottom: theme.spacing(1)
    },


    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    }

}));






export default function DownloadDemandePieceDetachee({ actionId }) {

    const classes = useStyles();

    const [loading, setLoading] = useState(false);


    useEffect(() => {


        const download = () => {

            console.log("DownloadDemandePieceDetachee download", actionId);

            axios.post(`api/reclamationActions/${actionId}/exporter-demande-piece-detachee`, {}, { responseType: 'blob' })
                .then(function (response) {

                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;

                    const contentDisposition = response.headers['content-disposition'];

                    const regex = new RegExp("filename[^;=\\n]*=['\"]?(?:UTF-\\d['\"]*)?([^;\\r\\n\"']*)['\"]?;?"); // https://stackoverflow.com/questions/23054475/javascript-regex-for-extracting-filename-from-content-disposition-header

                    const match = regex.exec(contentDisposition);

                    const filename = match[1]; // On prend le groupe 1

                    link.setAttribute('download', decodeURIComponent(filename));

                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                })
                .catch(function (error) {
                    console.log(error);
                })
                .then(function () {
                    // always executed
                    setLoading(false);
                });
        };


        if (loading) {
            download();
        }

    }, [actionId, loading]);



    

    return (
        <Button
            disabled={loading}
            onClick={() => setLoading(true)}
            variant="contained"
            color="secondary"
        >
            Télécharger la demande de pièce détachée
            {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
        </Button>
    );

}


